export default __webpack_public_path__ + "static/media/star-orange.a736cf33.svg";